export const UserDataLSKey = process.env.VUE_APP_USER_DATA_LS_KEY || 'userdata';
export const ApiEndpoint = process.env.VUE_APP_API_ENDPOINT || 'http://localhost:5000';
export const ShortenDomain = 'https://skrt.uno';

export default {
  UserDataLSKey,
  ApiEndpoint,
  ShortenDomain,
};
